/**
 * Five stars, the first `stars` of them filled.
 *
 * **Read aloud as one phrase**, from `label`, rather than as five symbols: "star, star, star, white
 * star" tells a listener nothing they can use.
 */
export function StarRating({ stars, label, className = '' }: { stars: number; label: string; className?: string }) {
    return (
        <span role="img" aria-label={label} className={`inline-flex items-center gap-0.5 leading-none ${className}`}>
            {[1, 2, 3, 4, 5].map((position) => (
                <span
                    key={position}
                    aria-hidden="true"
                    className={position <= stars ? 'text-amber-400' : 'text-slate-300 dark:text-slate-600'}
                >
                    ★
                </span>
            ))}
        </span>
    );
}
